export function filter_live_active_properties(properties = []) {
    return properties.filter((property) => {
        const status = String(property?.status || property?.property_status || "").toLowerCase();
        const is_inactive = property?.is_active === false || property?.active === false;
        const is_archived = property?.is_archived === true || property?.archived === true;

        return !is_inactive && !is_archived && status !== "inactive" && status !== "archived";
    });
}
